import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import InputMask from "@mona-health/react-input-mask";
import Input from "../Input";

type PhoneInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
  error?: FieldError;
};

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onChange, placeholder, error, label, ...rest }, ref) => {
    return (
      <div
        className={`relative flex flex-col`}
        key={`PHONE-${rest.defaultValue}`}
      >
        <InputMask
          ref={ref}
          mask={"+1 (999) 999 9999"}
          type="text"
          placeholder={placeholder ?? "+1"}
          value={value}
          onChange={onChange}
          {...rest}
        >
          <Input error={error} label={label} />
        </InputMask>
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
